import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'services/i18n'; // eslint-disable-line import/no-unresolved
import { RecoilRoot } from 'recoil';
import reportWebVitals from './reportWebVitals';
import addVersion from 'utils/version'
import './index.css';

import DataWrap from 'DataWrap';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <DataWrap>
        <App />
      </DataWrap>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('ttb-root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

addVersion();